<template>
	<div class="order-car-item">
		<div class="section-car-card">
			<nio-image
				class="head-photo"
				loader-height="100%"
				:image-style="{ objectFit: 'cover', objectPosition: 'center' }"
				:src="car.commodity_head_photo"
			/>
		</div>

		<div>
			<div class="section-quicklook">
				<div class="price-info">
					<span>官方二手车车辆配置</span>
				</div>
				<div style="display: flex; align-items: center" @click="goToConfigSnapshot">
					<span class="car-desc">{{ carDesc }}</span>
					<span><nio-icon :size="12" name="icon_arrows_right_2xs" /></span>
				</div>
			</div>

			<div class="section-quicklook">
				<div class="price-info">
					<span>购车总价</span>
				</div>
				<div>
					<span>¥ {{ formatCurrency(car.price) }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import util from '@/util/util'
import link from '@/util/link'
import { BrandEnum, BrandMap } from '@/util/constant'

export default {
	name: 'OrderCarItem',
	components: {},
	props: ['car', 'orderNo'],
	data() {
		return {}
	},
	computed: {
		carDesc() {
			const brandModel = `${BrandMap[this.car.brand || BrandEnum.NIO]} ${this.car.model || ''}`
			return [brandModel, this.car.car_paint_desc, this.car.interior_material_desc]
				.filter(Boolean)
				.join(' | ')
		}
	},
	methods: {
		formatCurrency: util.formatCurrency,
		goToConfigSnapshot() {
			if (this.$route.name === 'orderCreator') {
				link.goToRoute('/config-detail', {
					sku_code: this.car.commodity_code
				})
			} else {
				link.goToRoute('/config-detail', {
					order_no: this.orderNo,
					show_price: 'true'
				})
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@nio-fe/nio-app-ui/es/style/index';

.order-car-item {
	margin-bottom: 52px;
}
.section-car-card {
	background: #f7f7f8;
	width: 100%;
	height: 176px;
	position: relative;
	margin-bottom: 20px;
	overflow: hidden;

	.head-photo {
		position: absolute;
		left: 50%;
		top: 0;
		width: 100%;
		height: 100%;
		transform: translateX(-50%);

		&.measure {
			height: 0;
		}
	}

	.logo-certified {
		position: absolute;
		height: 16px;
		top: 20px;
		left: 20px;
	}
}

.divider {
	margin-top: 20px;
	margin-bottom: 20px;
	border-bottom: 1px solid $border_divider_primary;
}

.section-quicklook {
	display: flex;
	justify-content: space-between;
	align-items: center;
	@include body_2(1.7, 400, false);

	&:not(:last-child) {
		margin-bottom: 10px;
	}

	.price-info {
		width: 76px;
	}

	> :first-child {
		color: $text_secondary;
		@include body_2(1.7, 400, false);
	}
	> :last-child {
		display: inline-flex;
		align-items: center;
		color: $text_primary;
		@include body_2(1.7, 400, true);

		.car-desc {
			max-width: 218px;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.nio-icon {
			margin-left: 5px;
		}
	}
}
</style>
